<template>
<div class="chapter">
<div class="inner_page">
<a id="page_9">
<h3 class="sec_title">TIMELINE</h3>
<div class="line"><img alt="images" src="images/Img_0001-01.jpg"/></div>
<table class="table1">
<tbody><tr>
<td class="tt"><span class="bold">1194 BC</span></td>
<td class="tt1">The Greeks launch the first recorded amphibious expedition against Troy.</td>
</tr>
<tr>
<td class="tt"><span class="bold">693 BC</span></td>
<td class="tt1">Neo-Assyrian king Sennacherib conducts the first known amphibious assault landing against the Elamite city state.</td>
</tr>
<tr>
<td class="tt"><span class="bold">490 BC</span></td>
<td class="tt1">A huge Persian amphibious landing is defeated at Marathon, preserving European civilization.</td>
</tr>
<tr>
<td class="tt"><span class="bold">490–489 BC</span></td>
<td class="tt1">Julius Caesar successfully invades Britain.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1066</span></td>
<td class="tt1">William the Conqueror conquers Anglo-Saxon England after an amphibious landing.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1281</span></td>
<td class="tt1">The Mongols achieve some success at invading Japan, only to have the invasion fleet wrecked by a “divine wind”—a <em class="italic">kamikaze</em>.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1759</span></td>
<td class="tt1">A British landing climaxes with a battle on the Plains of Abraham in Canada, breaking French colonial power in the Americas.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1776</span></td>
<td class="tt1">A small raid on Nassau in the Bahamas marks the inauspicious combat debut of the new American Marine Corps.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1776</span></td>
<td class="tt1">A pinprick American raid on Whitehaven in northwest England outrages the British public. It is the first act in a series that will eventually turn the public and parliament against the war to suppress the American colonial rebellion.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1801</span></td>
<td class="tt1">General Sir Ralph Abercromby conducts the first modern amphibious assault at Aboukir Bay, Egypt. Though successful, Abercromby’s death shortly afterward assures that all his innovative ideas will be forgotten for half a century.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1815</span></td>
<td class="tt1">The disastrous failure of a British amphibious campaign against New Orleans in Louisiana guarantees the unhindered westward expansion of the young United States.</td>
</tr>
<tr>
<td class="tt"><a id="page_10"><span class="bold">1847</span></a></td>
<td class="tt1">An American expedition against Vera Cruz in Mexico both provides experience in operating far from fixed bases, and the first use of small steam-powered vessels in amphibious warfare.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1854</span></td>
<td class="tt1"> The disastrous Crimean invasion demonstrates that Britain has allowed its amphibious expertise to lapse.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1861–1865</span></td>
<td class="tt1"> The American Civil War sees the widespread use of riverine warfare, and Union control of the seas allows decisive amphibious campaigns.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1879</span></td>
<td class="tt1"> The Chilean landing at Pisagua is the decisive event in the War of the Pacific, the longest and bloodiest war in South American history.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1898</span></td>
<td class="tt1"> The Spanish-American War marks the debut of the US Marine Corps as a true expeditionary force, and America acquires Pacific colonies that will ultimately bring it into conflict with Imperial Japan.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1914</span></td>
<td class="tt1"> The United States launches its first full-scale campaign against a foreign objective, Vera Cruz in Mexico.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1915–1918</span></td>
<td class="tt1"> Although successful British amphibious raids are conducted against German-held port facilities along the European coastline, the disastrous Gallipoli campaign (1915–1916) leads to false conclusions that will stall the evolution of amphibious warfare for decades.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1920–1939</span></td>
<td class="tt1"> Despite general apathy, visionaries— primarily in the United States and Japan— continue to develop amphibious doctrine and equipment.</td>
</tr>
<tr>
<td class="tt"><span class="bold">April 1940</span></td>
<td class="tt1"> As World War II erupts, the Norway campaign is the first campaign on the Western Front. It conclusively demonstrates that neither the Axis nor the Allies are prepared for amphibious warfare.</td>
</tr>
<tr>
<td class="tt"><a id="page_11"><span class="bold">May–September 1940</span></a></td>
<td class="tt1"> The British use a hastily arranged amphibious evacuation to salvage what is left of their army in France.</td>
</tr>
<tr>
<td class="tt"><span class="bold">May–June 1941</span></td>
<td class="tt1"> The Germans launch a nearly disastrous airborne-amphibious invasion of Crete.</td>
</tr>
<tr>
<td class="tt"><span class="bold">July–December 1941</span></td>
<td class="tt1"> The Germans and Soviets fight a number of amphibious battles from the Baltic to the Black Sea. The successful Soviet campaign to halt the German offensive against Murmansk preserves a supply line for delivery of war supplies from America and Britain.</td>
</tr>
<tr>
<td class="tt"><span class="bold">December 1941–May 1942</span></td>
<td class="tt1"> The Japanese use amphibious landings to conduct a lightning conquest that reaches from the Indian Ocean to the Central Pacific. Notable events are near failure at Wake Island (December), the ill-managed invasion of the Philippines (December 1941–May 1942), and the first successful joint airborne-amphibious invasion at Timor (February 1942).</td>
</tr>
<tr>
<td class="tt"><span class="bold">August 1942</span></td>
<td class="tt1"> After a major naval victory at Midway in June, the United States begins to blunt and then roll back Japanese gains, beginning at Guadalcanal.</td>
</tr>
<tr>
<td class="tt"><span class="bold">August 1942</span></td>
<td class="tt1"> The British conduct a raid, actually a full-scale amphibious assault rehearsal, at Dieppe, France. It proves a total disaster.</td>
</tr>
<tr>
<td class="tt"><span class="bold">November 1942</span></td>
<td class="tt1"> Landings in northwest Africa, largely American, open a new front against Rommel’s forces in the desert.</td>
</tr>
<tr>
<td class="tt"><span class="bold">June 1943</span></td>
<td class="tt1"> American General Douglas MacArthur commences a masterful amphibious campaign to neutralize Japanese strength in the Southwest Pacific.</td>
</tr>
<tr>
<td class="tt"><span class="bold">July 1943</span></td>
<td class="tt1"> British and American forces invade Sicily, the first step in an Allied assault on southern Europe. George Patton, better known for armored tactics, skillfully uses tactical landings to outflank successive German defensive lines.</td>
</tr>
<tr>
<td class="tt"><a id="page_12"><span class="bold">November 1943</span></a></td>
<td class="tt1"> The Americans launch the first full-scale assault on a heavily fortified beach at Tarawa. In a vicious three-day battle the Americans prevail by sheer tenacity after near disaster.</td>
</tr>
<tr>
<td class="tt"><span class="bold">January 1944</span></td>
<td class="tt1"> Following a successful invasion of Italy in September 1943 the Allied offensive bogs down in mountainous terrain. Landings at Anzio are intended to outflank German defenses, but instead the Allies are penned into a small beachhead when the landing force fails to quickly capture surrounding high ground.</td>
</tr>
<tr>
<td class="tt"><span class="bold">June 1944</span></td>
<td class="tt1"> After a successful deception operation results in the German defenders concentrating in the Pas-de-Calais, the Allies stage the largest airborne-amphibious assault in history in Normandy.</td>
</tr>
<tr>
<td class="tt"><span class="bold">February 1944–March 1945</span></td>
<td class="tt1"> The Central Pacific drive toward Japan is conducted along doctrinal lines defined in the 1920s, with the conquest of a series of objectives for use as naval and air bases. The climactic event is the February–March 1945 battle for Iwo Jima.</td>
</tr>
<tr>
<td class="tt"><span class="bold">April–June 1945</span></td>
<td class="tt1"> American strategy has changed, and the two major Pacific amphibious drives converge at Okinawa instead of Formosa.</td>
</tr>
<tr>
<td class="tt"><span class="bold">August 1945</span></td>
<td class="tt1">The dropping of the atomic bombs eliminates the need for Operation <em class="italic">Downfall</em>, planned as the largest amphibious assault in history on two of the Japanese Home Islands, operations <em class="italic">Olympic</em> and <em class="italic">Coronet.</em></td>
</tr>
<tr>
<td class="tt"><span class="bold">October 1949</span></td>
<td class="tt1"> The climactic event of the Chinese Civil War is the invasion of Hainan, but several offshore islands remain in the hands of anti-communist forces until today.</td>
</tr>
<tr>
<td class="tt"><span class="bold">September 1950</span></td>
<td class="tt1"> North Korean forces nearly drive South Korean and American forces off the peninsula, but an American landing at <a id="page_13">Inchon severs North Korean supply lines and changes the course of the war.</a></td>
</tr>
<tr>
<td class="tt"><span class="bold">December 1950</span></td>
<td class="tt1"> After China enters the Korean War, major United Nations forces are encircled in northeastern Korea. They are saved by another of the most successful evacuations in history.</td>
</tr>
<tr>
<td class="tt"><span class="bold">October–November 1956</span></td>
<td class="tt1"> After Egyptian strongman Gamal Nasser seizes the Suez Canal, British, French, and Israeli forces invade Egypt. British landings at Port Said are the first significant use of helicopters in an assault from the sea.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1965–1972</span></td>
<td class="tt1"> The United States makes limited use of amphibious coastal raids in the Vietnam War, and more extensive use of riverine landings in the Mekong Delta region.</td>
</tr>
<tr>
<td class="tt"><span class="bold">1974</span></td>
<td class="tt1"> The Turkish invasion of Cyprus is one of the least known, but most audacious and strategically successful amphibious invasions in history.</td>
</tr>
<tr>
<td class="tt"><span class="bold">April–June 1982</span></td>
<td class="tt1"> When Argentina seizes the Falkland Islands, Britain is completely unprepared for a long-range amphibious campaign. A cobbled-together fleet suffers heavy losses. The result is another prediction that amphibious operations are a thing of the past.</td>
</tr>
<tr>
<td class="tt"><span class="bold">February 1991</span></td>
<td class="tt1"> In Operation <em class="italic">Desert Storm</em> the threat of an amphibious landing fixes about 40 percent of Iraqi forces in place, preventing them from participating in the land battle.</td>
</tr>
<tr>
<td class="tt"><span class="bold">November 2001</span></td>
<td class="tt1"> Initial Coalition operations in land-locked Afghanistan are conducted by special operations forces, but insertion of a major conventional force requires seizure of an airbase. The task is accomplished by a helicopter airlift of American Marines from ships in the Indian Ocean.</td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Timeline.vue?30a5a8fe